import { render, staticRenderFns } from "./AddBankAccountModal.vue?vue&type=template&id=e37d3abe&scoped=true"
import script from "./AddBankAccountModal.vue?vue&type=script&lang=js"
export * from "./AddBankAccountModal.vue?vue&type=script&lang=js"
import style0 from "./AddBankAccountModal.vue?vue&type=style&index=0&id=e37d3abe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37d3abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e37d3abe')) {
      api.createRecord('e37d3abe', component.options)
    } else {
      api.reload('e37d3abe', component.options)
    }
    module.hot.accept("./AddBankAccountModal.vue?vue&type=template&id=e37d3abe&scoped=true", function () {
      api.rerender('e37d3abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/Modal/AddBankAccountModal.vue"
export default component.exports